function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Text from '../Text';
const Description = _ref => {
  let {
    color = 'gray.7',
    fontSize = 1,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, _extends({
    color: color,
    fontSize: fontSize
  }, props));
};
Description.propTypes = {
  ...Text.propTypes
};
Description.displayName = 'Description';
export default Description;